export interface SubjectHeartbeatResponse {
    alive: 1;
    locked?: 0 | 1;
    timeout?: 1;
    error?: string;
}
